import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


// HOC: Función que toma un componente y devuelve otro mejorado
export function withLocation(Component) {
  return function WrappedComponent(props) {
    // Aquí usamos el Hook para obtener la location
    const location = useLocation();
    const navigate = useNavigate();
    
    // Devolvemos el componente original inyectándole la 'location'
    return <Component {...props} location={location} navigate={navigate} />;
  };
}